import React, { useState, useEffect } from 'react';
import { Grid, Menu, Card, Icon, Segment, Message } from 'semantic-ui-react';

import { Filters } from '../search/Filters';
import { Result } from '../search/Result';

export const ResultsContainer = ({ query, model, aliases, start = 0, size = 10 }) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [aggs, setAggs] = useState({});
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [noResults, setNoResults] = useState(false);
  const totalPages = Math.ceil(total / size);

  const handlePageChange = (page) => {
    if (page !== currentPage) {
      setCurrentPage(page);
    }
  };

  const rebuildPagination = () => {
    const pageItems = [];
    const maxPagesToShow = 5;
    const halfRange = Math.floor(maxPagesToShow / 2);
    let startPage = Math.max(1, currentPage - halfRange);
    let endPage = Math.min(totalPages, currentPage + halfRange);

    if (endPage - startPage < maxPagesToShow - 1) {
      if (startPage === 1) {
        endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
      } else if (endPage === totalPages) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }
    }

    if (currentPage > 1) {
      pageItems.push(
        <Menu.Item key="prev" onClick={() => handlePageChange(currentPage - 1)}>
          <Icon name="chevron left" />
        </Menu.Item>
      );
    }

    for (let i = startPage; i <= endPage; i++) {
      pageItems.push(
        <Menu.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Menu.Item>
      );
    }

    if (currentPage < totalPages) {
      pageItems.push(
        <Menu.Item key="next" onClick={() => handlePageChange(currentPage + 1)}>
          <Icon name="chevron right" />
        </Menu.Item>
      );
    }

    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2em' }}>
        <Menu pagination>{pageItems}</Menu>
      </div>
    );
  };

  async function getData() {
    setNoResults(false);
    setLoading(true);
    const q = encodeURIComponent(query);
    const offset = (currentPage - 1) * size;

    console.debug(`Fetching page ${currentPage}, offset ${offset}`);

    const result = await fetch(`/go/api/v1/search?q=${q}&model=${model}&start=${offset}&size=${size}`);
    const json = await result.json();
    console.debug(json);

    setAggs(json.aggregations);

    if (!json.hits || json.hits.hits.length === 0) {
      setNoResults(true);
      setResults([]);
      setLoading(false);
      return;
  }

  setTotal(json.hits.total);

  const cards = json.hits.hits.map((h, i) => (
    <Result data={h} alias={model} key={i} />
  ));
  setResults(cards);
  setLoading(false);
  }

  useEffect(() => { // Resets the pagination to 1 when switch between songs, composers or othr tabs
    setCurrentPage(1);
  }, [model, query]);

  useEffect(() => {
    getData();
  }, [query, model, aliases, currentPage]);

  return (
    <Segment attached='bottom' loading={loading}>
      <Grid>
        <Grid.Column width={4}>
          <Filters aggs={aggs} aliases={aliases} />
        </Grid.Column>
        <Grid.Column width={12}>
          {total > size && rebuildPagination()}
          {noResults ? (
            <Message info>No results found.</Message>
          ) : (
            <Card.Group itemsPerRow={3}>
              {results}
            </Card.Group>
          )}
        </Grid.Column>
      </Grid>
    </Segment>
  );
};
